if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
document.addEventListener('click', function(e) {
  const closeBtn = e.target.closest('.quick-add-modal__toggle');
  if (!closeBtn) return;
  
  // Tìm modal dialog element
  const dialog = document.querySelector('quick-add-modal[open], .quick-add-modal[open]');
  if (dialog) {
    dialog.removeAttribute('open');
    dialog.style.display = 'none';
  }
  
  // Reset body overflow
 document.body.style.overflow = '';
document.body.classList.remove('overflow-hidden', 'modal-open', 'scroll-lock', 'no-scroll');
document.documentElement.style.overflow = '';
document.documentElement.classList.remove('overflow-hidden', 'modal-open', 'scroll-lock', 'no-scroll');
  
  // Tìm overlay và ẩn đi
  const overlay = document.querySelector('.modal-overlay, .overlay, [class*="overlay"]');
  if (overlay) overlay.style.display = 'none';
});
